import React from 'react';

//INTERNAL
import { getAuthProvider, TokensType } from '../../common/authProvider';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { setAuthenticationSuccessInfo } from '../utils/LocalStorageHelper';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Loader from 'saur_ui_library/src/Atoms/Loader/Loader';
import { createGlobalStyle } from 'styled-components';

declare global {
    interface Window {
        ReactNativeWebView: any;
    }
}
interface IProps {
    lang: string
    realm: string
    clientIdIntern: string
    clientIdExtern: string
    idpUrl: string
    onToken: (
        tokens: TokensType,
        expireDate: number | undefined,
        roles: string[] | undefined,
        email: string
    ) => void
    children?: React.ReactNode
}

const AuthenticationWrapper: React.FC<IProps> = ({
    lang,
    realm,
    clientIdIntern,
    clientIdExtern,
    idpUrl,
    onToken,
    children
}) => {
    const keycloak = getAuthProvider(idpUrl, realm, clientIdExtern);

    const handleOnTokensAction = (tokens: any) => {
        const typedToken: TokensType = tokens as TokensType;
        if (typedToken.token && keycloak.tokenParsed) {
            const { exp, realm_access, email } = keycloak.tokenParsed;
            setAuthenticationSuccessInfo(
                typedToken,
                exp,
                email,
                realm_access?.roles
            );
            onToken(typedToken, exp, realm_access?.roles, email)
        }
    };

    const onTokenExpired = (event, error) => {
        if(event === 'onTokenExpired')
        {
            keycloak.updateToken(30).then(function(refreshed) {
                if(!refreshed)
                    console.log('Failed to refresh token');
            }).catch(function() {
                console.log('Failed to refresh token');
            });
        }
    }

    return (
        <div className='authentication-component'>
            <Styles />
            {!!keycloak && (
                <ReactKeycloakProvider
                    authClient={keycloak}
                    onTokens={handleOnTokensAction}
                    onEvent={onTokenExpired}
                    LoadingComponent={
                        <Container className='login-screen-loading'>
                            <Loader />
                        </Container>
                    }
                >
                    {children}
                </ReactKeycloakProvider>
            )}
        </div>
    )
};

const Styles = createGlobalStyle`
.authentication-component{
    height: inherit
}
`;
export default AuthenticationWrapper;
